import LoadingSpinner from 'ui-kit/components/LoadingSpinner';
import PDFIcon from 'ui-kit/icons/PDF';

const PdfCellRenderer = (props: any) => {
  const identifierField = props?.identifierField ?? 'orderNumber';
  const identifierValue = props?.data?.[identifierField];
  const invoiceStatus = props?.data?.invoiceStatus || '';
  const paymentId =
    props?.data?.paymentId ??
    props?.data?.PaymentId ??
    props?.data?.payment?.paymentId ??
    props?.data?.Payment?.PaymentId;

  const transmittalInvoiceStatuses = props?.transmittalInvoiceStatuses;

  // Service Order Invoices: show only for configured invoice statuses (e.g. Wire / Manual Pay in Process)
  if (transmittalInvoiceStatuses?.length) {
    if (!transmittalInvoiceStatuses.includes(invoiceStatus)) {
      return null;
    }
  } else {
    // Report & Pay: don't show for ePay; require paymentId on the row
    const isEPayment = invoiceStatus.toLowerCase().includes('epay');
    if (isEPayment) {
      return null;
    }

    if (!paymentId) {
      return null;
    }
  }

  if (
    props?.paymentId === paymentId &&
    props?.orderNumber === identifierValue &&
    props?.executeTransmittalSheetStatus === 'pending'
  )
    return <LoadingSpinner status="pending" variant="circle" showLabel={false} />;

  return (
    <span
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: paymentId ? 'pointer' : 'default',
      }}
      onClick={() => {
        if (paymentId) {
          props?.onClick(paymentId, identifierValue);
        }
      }}
      data-testid="transmittal-sheet-icon"
      aria-label="View Payment Transmittal Sheet"
    >
      {PDFIcon({ fontSize: 'small' })}
    </span>
  );
};

export default PdfCellRenderer;
